import scrollPagination, { ScrollPaginationProps } from '@anm/helpers/array/scrollPagination';
import usePropsChange from '@anm/hooks/usePropsChange';
import compact from 'lodash/fp/compact';
import compose from 'lodash/fp/compose';
import flatten from 'lodash/fp/flatten';
import { useEffect, useState } from 'react';

const getListFromPages = (pages: any[][]) => compose(compact, flatten)(pages);

export const usePagination = <T extends any[]>(props: ScrollPaginationProps<T>) => {
  const isPropsChange = usePropsChange(props);
  const [pagination, setPagination] = useState(scrollPagination(props));
  const { currentPages, next } = pagination;
  const [pages, setPages] = useState([...currentPages]);

  const nextPage = () => {
    const nextPages = next();
    setPages([...nextPages]);
  };

  useEffect(() => {
    setPagination(scrollPagination(props));
  }, [isPropsChange]);

  useEffect(() => {
    setPages([...currentPages]);
  }, [pagination]);

  const shortList = getListFromPages(pages);
  return { shortList, nextPage, currentPageNumber: currentPages.length };
};
